/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { SecondeResidenceDto } from '../models/seconde-residence-dto';


/**
 * Fonctions de gestion des secondes résidences
 */
@Injectable({
  providedIn: 'root',
})
export class SecondesResidencesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation secondesResidencesGetList
   */
  static readonly SecondesResidencesGetListPath = '/api/secondes-residences/list';

  /**
   * Renvoie la liste des secondes résidences.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<SecondeResidenceDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SecondeResidenceDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des secondes résidences.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesGetList(params?: {
  }): Observable<Array<SecondeResidenceDto>> {

    return this.secondesResidencesGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SecondeResidenceDto>>) => r.body as Array<SecondeResidenceDto>)
    );
  }

  /**
   * Path part for operation secondesResidencesLoadList
   */
  static readonly SecondesResidencesLoadListPath = '/api/secondes-residences/load-list';

  /**
   * Renvoie la liste des secondes résidences (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des secondes résidences (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.secondesResidencesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation secondesResidencesGet
   */
  static readonly SecondesResidencesGetPath = '/api/secondes-residences/{id}';

  /**
   * Renvoie la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesGet$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    id: number;
  }): Observable<StrictHttpResponse<SecondeResidenceDto>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidenceDto>;
      })
    );
  }

  /**
   * Renvoie la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesGet(params: {

    /**
     * Identifiant de la seconde résidence
     */
    id: number;
  }): Observable<SecondeResidenceDto> {

    return this.secondesResidencesGet$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidenceDto>) => r.body as SecondeResidenceDto)
    );
  }

  /**
   * Path part for operation secondesResidencesPut
   */
  static readonly SecondesResidencesPutPath = '/api/secondes-residences/{id}';

  /**
   * Met à jour la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPut$Response(params: {

    /**
     * Identifiant de la seconde résidence à mettre à jour
     */
    id: number;

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<StrictHttpResponse<SecondeResidenceDto>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidenceDto>;
      })
    );
  }

  /**
   * Met à jour la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPut(params: {

    /**
     * Identifiant de la seconde résidence à mettre à jour
     */
    id: number;

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<SecondeResidenceDto> {

    return this.secondesResidencesPut$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidenceDto>) => r.body as SecondeResidenceDto)
    );
  }

  /**
   * Path part for operation secondesResidencesDelete
   */
  static readonly SecondesResidencesDeletePath = '/api/secondes-residences/{id}';

  /**
   * Supprime la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesDelete$Response(params: {

    /**
     * Identifiant de la seconde résidence à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesDelete(params: {

    /**
     * Identifiant de la seconde résidence à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.secondesResidencesDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation secondesResidencesPost
   */
  static readonly SecondesResidencesPostPath = '/api/secondes-residences';

  /**
   * Crée la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPost$Response(params: {

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<StrictHttpResponse<SecondeResidenceDto>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesService.SecondesResidencesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidenceDto>;
      })
    );
  }

  /**
   * Crée la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPost(params: {

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<SecondeResidenceDto> {

    return this.secondesResidencesPost$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidenceDto>) => r.body as SecondeResidenceDto)
    );
  }

}
